export function getWidth(div) {
    if (div) {
        if (div.current) {
            div = div.current;
        }
        return div.clientWidth * 0.99;
    }
    return window.innerWidth - 30;
}

export const WIDTH = window.innerWidth - 30;
export const HEIGHT = 130;
export const START = 'START';
export const END = 'END';

